import { GetRulesParams, Rule } from 'models/rabbit';
import * as Actions from 'actions/rabbit';
import { RuleData, Rules } from 'actions/rabbit';
import { Repository } from 'utils/repository';

export type State = Repository<Rule, GetRulesParams, 'id'>;

const initState: State = Repository.create('id');

type Action =
  | Rules.Action
  | RuleData.Action;

export const reducer = (state: State = initState, action: Action): State => {
  switch (action.type) {
    case Actions.RABBIT_RULE_DATA_LOAD_START:
      return state.setFetched(action.params, false);
    case Actions.RABBIT_RULE_DATA_LOAD_FAILURE:
      return state.setFetched(action.params, true);
    case Actions.RABBIT_RULE_DATA_LOAD_SUCCESS:
      return state
        .setFetched(action.params, true)
        .setTotal(action.params, action.total)
        .setData(action.params, action.data);
    case Actions.RABBIT_RULE_LOCK:
      return state.setLocked(action.ruleId, true);
    case Actions.RABBIT_RULE_UNLOCK:
      return state.setLocked(action.ruleId, false);
    case Actions.RABBIT_RULE_CHANGE:
      return state.changeModel(action.rule.id, action.options.delete ? undefined : action.rule);

    default:
      return state;
  }
};
